import Home from '@/views/home/Home'
import ParentComponent from '@/components/parentComponent/ParentComponent'
export default [
  {
    path: '',
    name: 'home',
    meta: {
      title: '首页',
    },
    component: Home
  },
  {
    path: '/convert',
    mame: 'convert',
    meta: {
      title: '转换'
    },
    component: () => import('@/views/convert/Convert'),
    children: [
      {
        path: 'pdfConvert',
        name: 'pdfConvert',
        meta: {
          title: 'pdf转换',
        },
        component: ParentComponent,
        children: [
          {
            path: 'pdfToWord',
            name: 'pdfToWord',
            meta: {
              title: 'PDF转Word',
            },
            component: () => import('@/views/convert/pdfConvert/PdfToWord')
          },
          {
            path: 'pdfToImage',
            name: 'pdfToImage',
            meta: {
              title: 'PDF转图片',
            },
            component: () => import('@/views/convert/pdfConvert/PdfToImage')
          },
          {
            path: 'pdfToPPT',
            name: 'pdfToPPT',
            meta: {
              title: 'PDF转PPT',
            },
            component: () => import('@/views/convert/pdfConvert/PdfToPPT')
          },
          {
            path: 'pdfToTxt',
            name: 'pdfToPTxt',
            meta: {
              title: 'PDF转Txt',
            },
            component: () => import('@/views/convert/pdfConvert/PdfToTxt')
          },
          {
            path: 'pdfToExcel',
            name: 'pdfToPExcel',
            meta: {
              title: 'PDF转Excel',
            },
            component: () => import('@/views/convert/pdfConvert/PdfToExcel')
          },
        ]
      },
      {
        path: 'convertToPdf',
        name: 'convertToPdf',
        meta: {
          title: '转换成PDF',
        },
        component: ParentComponent,
        children: [
          {
            path: 'excelToPdf',
            name: 'excelToPdf',
            meta: {
              title: 'Excel转PDF',
            },
            component: () => import('@/views/convert/convertToPdf/ExcelToPdf')
          },
          {
            path: 'imageToPdf',
            name: 'imageToPdf',
            meta: {
              title: '图片转PDF',
            },
            component: () => import('@/views/convert/convertToPdf/ImageToPdf')
          },
          {
            path: 'PPTToPdf',
            name: 'PPTToPdf',
            meta: {
              title: 'PPT转PDF',
            },
            component: () => import('@/views/convert/convertToPdf/PPTToPdf')
          },
          {
            path: 'wordToPdf',
            name: 'wordToPdf',
            meta: {
              title: 'word转PDF',
            },
            component: () => import('@/views/convert/convertToPdf/WordToPDF')
          },
        ]
      },
      {
        path: 'cadConvert',
        name: 'cadConvert',
        meta: {
          title: 'CAD转换',
        },
        component: ParentComponent,
        children: [
          {
            path: 'cadToPdf',
            name: 'cadToPdf',
            meta: {
              title: 'CAD转PDF',
            },
            component: () => import('@/views/convert/cadConvert/CADToPdf')
          },
          {
            path: 'pdfToCad',
            name: 'pdfToCad',
            meta: {
              title: 'PDF转CAD',
            },
            component: () => import('@/views/convert/cadConvert/PdfToCAD')
          }
        ]
      },
    ]
  }
]
